// src/components/documents/fieldStyles.js — doced-8f3a61c2 (Document editor, Stage 4, round 1 fixes)
//
// ONE look for every box on the document pages: text inputs and selects share height (44px), padding,
// border, radius and font; every select draws the same chevron (the browser's own arrow is hidden,
// so it looks the same in every browser). FIELD for the page; LINE_* for the denser line-item rows.

const BASE = 'w-full h-[44px] min-h-[44px] border border-gray-300 rounded-lg bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#5F4EC9]/40 focus:border-[#5F4EC9] disabled:bg-gray-50 disabled:text-gray-600 disabled:cursor-not-allowed';

export const FIELD = `${BASE} px-3 text-[15px]`;
export const SELECT = `${FIELD} appearance-none pr-9 cursor-pointer truncate`;
export const LINE_FIELD = `${BASE} px-2 text-sm`;
export const LINE_SELECT = `${LINE_FIELD} appearance-none pr-8 cursor-pointer truncate`;

const CHEVRON = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")";
/** The one chevron, for style={SELECT_STYLE} on every select. */
export const SELECT_STYLE = Object.freeze({ backgroundImage: CHEVRON, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 10px center', backgroundSize: '16px 16px' });
